import { useSelector } from "react-redux";

import pluralize from "pluralize";

export function useClientResources(c) {
  const { isSyncMeetingsEnabled, comments, attachmentsLoading, attachments } =
    useSelector(({ hubly }) => {
      return {
        ...hubly.data.hub.clientCard,
        isSyncMeetingsEnabled:
          hubly.data.hub.selected.hub?.preferences?.sync?.shouldSyncMeetings,
      };
    });

  const resources = [
    { name: "Household", available: Boolean(c?.householdId), syncable: true },
    {
      name: "Tag",
      available: Boolean(c?.tags?.length),
      size: c?.tags?.length,
      syncable: true,
    },
    {
      name: "Client Date",
      available: Boolean(c?.clientDates?.length),
      size: c?.clientDates?.length,
      syncable: true,
    },
    {
      name: "Client Meeting",
      available: Boolean(c?.events?.length),
      size: c?.events?.length,
      syncable: isSyncMeetingsEnabled,
    },
    { name: "Comment", available: Boolean(comments), syncable: true },
    {
      name: "Attachment",
      available: Boolean(attachments?.length),
      size: attachments?.length,
      syncable: false,
    },
  ]
    .filter(({ available }) => {
      return available;
    })
    .map((e) => {
      return {
        key: pluralize(e.name, 2),
        label:
          "size" in e
            ? `${e.size} ${pluralize(e.name, e.size)}`
            : `${e.name}(s)`,
        syncable: e.syncable,
      };
    });

  return [comments === "loading" || attachmentsLoading, resources];
}

export default useClientResources;
